export default __webpack_public_path__ + "static/media/093-palace.758c2274.svg";